/* @flow */

import { rem } from 'polished';

import { outlineWidth } from 'src/shared/app/base/style/token/box';
import { baseFontSize } from '@braindate/ui/lib/token/typography';
import { visuallyHidden } from 'src/shared/app/base/style/token/helper';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

const checkbox = 'input[type=checkbox]:not(.MuiSwitch-input)';
const radio = 'input[type=radio]:not(.ignore)';

export default {
  [`${checkbox}, ${radio}`]: {
    ...visuallyHidden,

    '&:focus + label': {
      outlineOffset: 2,
      // Style and width need to be explicitly set for Firefox
      outlineStyle: 'solid',
      outlineWidth,
    },

    '& + label:not(.ignore)': {
      position: 'relative',

      display: 'flex',
      alignItems: 'center',

      margin: [rem(8, baseFontSize), 0],
      paddingLeft: '2em',

      color: ({ theme }: ThemeFunction) => theme.textColorTertiary,
      fontWeight: 400,

      cursor: 'pointer',
      userSelect: 'none',
      fontSize: rem(14, baseFontSize),
    },
    '& + label:before': {
      content: "''",
      position: 'absolute',
      top: '50%',
      left: 3,
      transform: 'translateY(-50%)',
      width: 9,
      height: 9,
      outlineWidth: 1,
      outlineOffset: 2,
      outlineStyle: 'solid',
      outlineColor: 'currentColor',
    },
    '&:checked + label:not(.ignore)': {
      color: ({ theme }: ThemeFunction) => theme.textColorTertiary,
    },
    '&:checked + label:before': {
      backgroundColor: 'currentColor',
      outlineColor: ({ theme }: ThemeFunction) => theme.textColorTertiary,
    },
  },
  [checkbox]: {
    '& + label:before': {
      borderRadius: 1,
    },
  },
  [radio]: {
    '& + label:before': {
      borderRadius: '50%',
    },
  },
};
